import { createAutorenewInCart } from '@b2b/types/cart';
import angular, { INgModelController, IOnChangesObject } from 'angular';

class CartOrderConfirmationEmailController {
  static $inject = [];
  values = {
    sendEmailConfirmationToBillingContactOnly: 1,
    doNotSendEmailConfirmations: 0,
    sendEmailConfirmations: 2,
  };

  ngModel!: number | false;
  ngModelCtrl!: INgModelController;
  isAccount = false;
  hasMultipleEvents = false;
  autorenewInCart = createAutorenewInCart();

  $onChanges(changes: IOnChangesObject) {
    if (changes.autorenewInCart && this.autorenewInCart.enabled) {
      this.forceSendConfirmationToBillingContact();
    }
  }

  ngModelChange() {
    this.ngModelCtrl.$setViewValue(this.ngModel);
  }

  forceSendConfirmationToBillingContact() {
    this.ngModel = this.values.sendEmailConfirmationToBillingContactOnly;
  }
}

export const CartOrderConfirmationEmailComponentModule = angular
  .module('acme.view.application.cart.components.cart-order-confirmation-email', [])
  .component('acmeCartOrderConfirmationEmail', {
    templateUrl:
      'views/application/views/cart/components/cart-order-confirmation-email/cart-order-confirmation-email.component.tpl.html',
    controller: CartOrderConfirmationEmailController,
    require: { ngModelCtrl: 'ngModel' },
    bindings: {
      ngModel: '<',
      isAccount: '<',
      hasMultipleEvents: '<',
      autorenewInCart: '<',
    },
  }).name;
